/**
 * Resolve the final column render order: re-append any key present in
 * `columnKeys` (current `columns`) but missing from `baseOrder` (the
 * persisted / live `orderedFields`).
 *
 *  orderedFields          column unmounts         column re-mounts
 *  [ …, actions ] ──────► [ … ]           ──────► columns: [ …, actions ]
 *  (canEdit=true)         (canEdit=false)         orderedFields: [ … ]
 *                                                        │
 *            without: hidden until refresh ✗             │ resolveColumnOrder
 *                                                        ▼
 *                                        [ …, actions ]  re-appended ✓
 *
 * ADDITIVE ONLY — never removes or reorders existing entries; missing keys
 * append in `columnKeys` order (mirrors the existing `syncColumnOrder`
 * newColumns append). Consumed by the shared DataGrid `computedColumns` —
 * i.e. every grid in the app.
 */
export function resolveColumnOrder(baseOrder: string[], columnKeys: string[]): string[] {
  const missing = columnKeys.filter((field) => !baseOrder.includes(field));
  return missing.length ? [...baseOrder, ...missing] : baseOrder;
}
